import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from "@headlessui/react";
import { FunnelIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { ButtonBase } from "@repo/ui/index.tsx";
import { memo, useState, Fragment } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { IMultiColumnFilter } from "Tables/table.types";
import useRouterHandlerHook from "../../_hooks/useRouterHandlerHook";
import ButtonDummy from "../../Buttons/DummyButton";
import FilterType from "./FilterType";
import { stringUtility } from "@repo/utilities/string.utility.ts";

function MultipleColumnFilter({
  multipleColumnFilterOptions,
}: IMultiColumnFilter) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const methods = useForm();
  const TYPE_ORDER = ["text", "number", "selector", "date", "searchSelector"];
  const { navigateTo, navigateBackTo } = useRouterHandlerHook();
  const handleRemoveAll = () => {
    const filterKeys = multipleColumnFilterOptions.map((opt) => opt.code);
    navigateBackTo({ searchKey: filterKeys });
    multipleColumnFilterOptions.map((opt) => {
      methods.setValue(`${opt.code}_enabled`, false);
      methods.setValue(`${opt.code}`, "");
    });
  };

  const handleApplyFilters = methods.handleSubmit((values) => {
    const filters: Record<string, string> = { page: "1" };
    multipleColumnFilterOptions.forEach((opt) => {
      const isEnabled = values[`${opt.code}_enabled`];
      let fieldValue = values[opt.code];
      if (opt.type === "selector" && fieldValue) {
        fieldValue = fieldValue.code
      }
      if (opt.type === "number" && fieldValue) {
        fieldValue = stringUtility.inrToNumber(values[opt.code]);
      }

      if (isEnabled && fieldValue) {
        filters[opt.code] = fieldValue;
      } else {
        return navigateBackTo({ searchKey: opt.code });
      }
    });

    navigateTo({ search: filters });
    setIsPopoverOpen(false);
  });

  return (
    <>
      <FormProvider {...methods}>
        <Popover className="relative  ">
          <PopoverButton
            as={ButtonDummy}
            icon={<FunnelIcon className="size-5 " />}
            className=" size-7 cursor-pointer"
            onClick={() => setIsPopoverOpen(!isPopoverOpen)}
          />

          <Transition
            // as="div"
            // show={isPopoverOpen}
            as={Fragment}
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-100 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <PopoverPanel className="absolute right-[110%] -top-1 p-4 bg-white rounded-lg ring-1 ring-extraLightGray shadow-lg max-h-96 flex gap-4 flex-col justify-between z-50 origin-top-right will-change-transform">
              {({ close }) => (
                <>
                  <button
                    type="button"
                    className="h-4 right-2 absolute top-2"
                    onClick={() => close()}
                  >
                    <XCircleIcon className="size-5 text-primary rounded-full" />
                  </button>

                  {/* rest of your content */}

                  <div className="flex flex-col items-end gap-4 overflow-auto">
                    {TYPE_ORDER.map((type) => {
                      const groupItems = multipleColumnFilterOptions.filter(
                        (opt) => opt.type === type
                      );

                      if (!groupItems.length) return null;

                      return (
                        <>
                          <div className="flex flex-col gap-1">
                            <h4 className="shadow-sm flex   text-start text-primary rounded-lg text-xs font-semibold text-gray-600 uppercase     border-extraLightGray">
                              {type}
                            </h4>
                            <div
                              key={type}
                              className=" border border-extraLightGray rounded-lg px-2 py-2 "
                            >
                              <div className="flex flex-col gap-3">
                                {groupItems.map((data) => (
                                  <FilterType key={data.id} data={data} />
                                ))}
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>
                  <div className="flex justify-end gap-2">
                    <ButtonBase
                      type="button"
                      buttonType="secondary"
                      text="Remove"
                      onClick={handleRemoveAll}
                      className="  h-8 px-2"
                    />
                    <ButtonBase
                      type="button"
                      buttonType="primary"
                      text="Apply filters"
                      onClick={handleApplyFilters}
                      className="  min-h-8 px-2"
                    />
                  </div>
                </>
              )}
            </PopoverPanel>
          </Transition>
        </Popover>
      </FormProvider>
    </>
  );
}

export default memo(MultipleColumnFilter);
